<div [chart]="precipitationChart"></div>
